module.exports = __webpack_public_path__ + "static/media/subGoogle4.28c857bd.png";